(function () {
  'use strict';

  const map = window.CloatBrandModelMap || {};
  const CASE_OPTION_NAME = 'Case Type';

  const wrapper       = document.getElementById('bms-wrapper');
  const trigger       = document.getElementById('bms-trigger');
  const popup         = document.getElementById('bms-popup');
  const overlay       = document.getElementById('bms-overlay');
  const brandPanel    = document.getElementById('bms-brand-panel');
  const modelPanel    = document.getElementById('bms-model-panel');
  const modelList     = document.getElementById('bms-model-list');
  const brandList     = document.getElementById('bms-brand-list');
  const brandLabel    = document.getElementById('bms-brand-label');
  const modelLabel    = document.getElementById('bms-model-label');
  const modelTitle    = document.getElementById('bms-model-panel-title');
  const backBtn       = document.getElementById('bms-back');
  const closeBtn      = document.getElementById('bms-close');
  const closeBtn2     = document.getElementById('bms-close-2');
  const lpBrand       = document.getElementById('lp-brand');
  const lpModel       = document.getElementById('lp-model');
  const validationMsg = document.getElementById('bms-validation-msg');
  const brandSearch   = document.getElementById('bms-brand-search');
  const modelSearch   = document.getElementById('bms-model-search');

  let selectedBrand = null;
  let selectedModel = null;

  function openPopup() {
    popup.classList.remove('bms-hidden');
    overlay.classList.remove('bms-hidden');
    trigger.setAttribute('aria-expanded', 'true');
    showBrandPanel();
    brandSearch.value = '';
    filterBrandList('');
    setTimeout(() => brandSearch.focus(), 100);
  }

  function closePopup() {
    popup.classList.add('bms-hidden');
    overlay.classList.add('bms-hidden');
    trigger.setAttribute('aria-expanded', 'false');
  }

  function showBrandPanel() {
    brandPanel.classList.remove('bms-hidden');
    modelPanel.classList.add('bms-hidden');
  }

  function filterBrandList(query) {
    const btns = brandList.querySelectorAll('.bms-brand-btn');
    let anyVisible = false;
    btns.forEach(btn => {
      const match = btn.dataset.brand.toLowerCase().includes(query.toLowerCase());
      btn.style.display = match ? '' : 'none';
      if (match) anyVisible = true;
    });
    let noResults = brandList.querySelector('.bms-no-results');
    if (!anyVisible) {
      if (!noResults) {
        noResults = document.createElement('p');
        noResults.className = 'bms-no-results';
        noResults.textContent = 'No brands found';
        brandList.appendChild(noResults);
      }
      noResults.style.display = '';
    } else if (noResults) {
      noResults.style.display = 'none';
    }
  }

  function showModelPanel(brand) {
    modelTitle.textContent = brand;
    modelList.innerHTML = '';
    modelSearch.value = '';
    const models = Object.keys(map[brand] || {});
    models.forEach(model => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'bms-model-btn' + (model === selectedModel ? ' bms-active' : '');
      btn.textContent = model;
      btn.dataset.model = model;
      btn.addEventListener('click', () => selectModel(brand, model));
      modelList.appendChild(btn);
    });
    brandPanel.classList.add('bms-hidden');
    modelPanel.classList.remove('bms-hidden');
    setTimeout(() => modelSearch.focus(), 100);
  }

  function filterModelList(query) {
    const btns = modelList.querySelectorAll('.bms-model-btn');
    let anyVisible = false;
    btns.forEach(btn => {
      const match = btn.dataset.model.toLowerCase().includes(query.toLowerCase());
      btn.style.display = match ? '' : 'none';
      if (match) anyVisible = true;
    });
    let noResults = modelList.querySelector('.bms-no-results');
    if (!anyVisible) {
      if (!noResults) {
        noResults = document.createElement('p');
        noResults.className = 'bms-no-results';
        noResults.textContent = 'No devices found';
        modelList.appendChild(noResults);
      }
      noResults.style.display = '';
    } else if (noResults) {
      noResults.style.display = 'none';
    }
  }

  function selectModel(brand, model) {
    selectedBrand = brand;
    selectedModel = model;
    brandLabel.textContent = brand;
    modelLabel.textContent = model + ' ▾';
    trigger.classList.add('bms-selected');
    lpBrand.value = brand;
    lpModel.value = model;
    validationMsg.classList.add('bms-hidden');
    closePopup();
    filterCaseTypes(brand, model);
  }

  function filterCaseTypes(brand, model) {
    if (!brand || !model) return;
    const availableCases = (map[brand] && map[brand][model]) ? map[brand][model] : [];
    applyFilter(availableCases);
  }

  function applyFilter(availableCases) {
    const variantPicker = document.querySelector('variant-picker');
    if (!variantPicker) return;
    const optionGroups = variantPicker.querySelectorAll('.m-product-option');
    optionGroups.forEach(group => {
      const optionName = group.querySelector('[data-option-name]')?.dataset.optionName;
      if (optionName !== CASE_OPTION_NAME) return;
      const nodes = group.querySelectorAll('.m-product-option--node');
      let firstVisibleInput = null;
      let currentCheckedVisible = false;
      nodes.forEach(node => {
        const value = node.dataset.value;
        const isAvailable = availableCases.length === 0 || availableCases.includes(value);
        if (isAvailable) {
          node.style.setProperty('display', '', 'important');
          const input = node.querySelector('input[type="radio"]');
          if (!firstVisibleInput && input) firstVisibleInput = input;
          if (input && input.checked) currentCheckedVisible = true;
        } else {
          node.style.setProperty('display', 'none', 'important');
        }
      });
      if (!currentCheckedVisible && firstVisibleInput) {
        firstVisibleInput.checked = true;
        firstVisibleInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  function watchVariantPickerForReset() {
    const productInfo = document.querySelector('product-info');
    if (!productInfo) return;
    const observer = new MutationObserver(() => {
      if (selectedBrand && selectedModel) {
        requestAnimationFrame(() => filterCaseTypes(selectedBrand, selectedModel));
      }
    });
    observer.observe(productInfo, { childList: true, subtree: true });
  }

  function hookMinimogEvents() {
    if (typeof MinimogEvents === 'undefined' || typeof MinimogTheme === 'undefined') {
      setTimeout(hookMinimogEvents, 200);
      return;
    }
    MinimogEvents.subscribe(MinimogTheme.pubSubEvents.variantChange, () => {
      if (selectedBrand && selectedModel) {
        requestAnimationFrame(() => filterCaseTypes(selectedBrand, selectedModel));
      }
    });
  }

  function interceptAddToCart() {
    const productForm = document.querySelector('form[action="/cart/add"]');
    if (!productForm) return;
    productForm.addEventListener('submit', function (e) {
      if (!selectedBrand || !selectedModel) {
        e.preventDefault();
        e.stopImmediatePropagation();
        validationMsg.classList.remove('bms-hidden');
        wrapper.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, true);
  }

  trigger.addEventListener('click', openPopup);
  overlay.addEventListener('click', closePopup);
  closeBtn.addEventListener('click', closePopup);
  closeBtn2.addEventListener('click', closePopup);
  backBtn.addEventListener('click', showBrandPanel);
  brandSearch.addEventListener('input', e => filterBrandList(e.target.value));
  modelSearch.addEventListener('input', e => filterModelList(e.target.value));
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && !popup.classList.contains('bms-hidden')) closePopup();
  });
  document.querySelectorAll('.bms-brand-btn').forEach(btn => {
    btn.addEventListener('click', () => showModelPanel(btn.dataset.brand));
  });

  interceptAddToCart();
  watchVariantPickerForReset();
  hookMinimogEvents();

})();
